function formatNumber(num) {
    num = parseInt(num)
    if (num >= 1000) {
        const rounded = (num / 1000).toFixed(1); // Divide by 1000 and round to 1 decimal place
        return `${rounded}k`; // Add the 'k' suffix
    } else {
        return num.toString(); // Return the number as a string for 3 digits or less
    }
}

export function LiveGameResource({ resourceType, resourceCount, resourcePerMin, resourceVills, leftSide }) {
    return (
        <div className="text-white flex flex-col w-[120px] h-[96px] justify-center">
            <div className="flex flex-row justify-center">
                <h1 className="text-xl font-semibold">{parseInt(resourceCount)}</h1>
                <img className='w-9' src={`/liveGameIcons/${resourceType}.png`} />
            </div>
            <div className="flex flex-row justify-center">
                <div className="text-[#b1b1b1] flex flex-row text-[18px]">
                    <h1 className="">{formatNumber(resourcePerMin * 60)}</h1>
                    <h1 className="mt-[5px] text-[14px]">/min</h1>
                </div>
                <img className='w-[18px] h-[18px] mt-[4px]' src={`/liveGameIcons/worker_count.png`} alt="" />
                <h1 className="h-4 text-[20px] -mt-[2px]">{parseInt(resourceVills)}</h1>
            </div>
        </div>
    )
}